import React, { useState, Fragment } from "react";

import { nanoid } from "nanoid";
import TextareaAutosize from "react-textarea-autosize";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { catalogTableLabel } from "../../app/helpers/helperCatalogs";
import "./multimedia-component/table-edit-scratch.css"
import EditableRow from "./problem-component/EditableRow";
import ReadOnlyRow from "./problem-component/ReadOnlyRow";
import Swal from "sweetalert2";

const initialData = {
  catalogproblems_id: "",
  CatProblem_To_ModProblem: "",
  matter: "",
  solution: "",

}
const NewCatalogRelationProblemsDetails = ({ tableRecords, setValues, comboData, field, moduleText, occupation, css_class }) => {

  const { t } = useTranslation();
  const [addFormData, setAddFormData] = useState({ initialData });
  const [editFormData, setEditFormData] = useState({ initialData });
  const [editContactId, setEditContactId] = useState(null);

  const handleChange = (event, idField, type) => {

    if (type === "text") {
      setAddFormData((values) => ({ ...values, [event.target.name]: event.target.value }));
    } else if (type === "relation") {
      if (event != null) {
        
        setAddFormData((values) => ({ ...values, [idField]: event }));
      } else {
        setAddFormData((values) => ({ ...values, [idField]: "" }));
      }
    }

  };

  const handleEditFormChange = (event, idField, type) => {

    if (type === "text") {
      setEditFormData((values) => ({ ...values, [event.target.name]: event.target.value }));
    } else if (type === "relation") {
      if (event != null) {
        
        setEditFormData((values) => ({ ...values, [idField]: event }));
      } else {
        setEditFormData((values) => ({ ...values, [idField]: "" }));
      }
    }

  };

  const handleAddFormSubmit = (event) => {
    event.preventDefault();
    let flagExist = false;

    if (addFormData && addFormData.matter &&
      addFormData.solution &&
      addFormData.CatProblem_To_ModProblem) {

      const newModuleFile = {
        id: nanoid(),
        CatProblem_To_ModProblem: addFormData.CatProblem_To_ModProblem,
        matter: addFormData.matter,
        solution: addFormData.solution
      };

      let newModuleProblems = [];

      if (tableRecords && tableRecords.length > 0) {

        const found = tableRecords.find((element) => element.CatProblem_To_ModProblem.id === newModuleFile.CatProblem_To_ModProblem.id);

        if (found) {
          flagExist = true;
          Swal.fire(t("titles.error"), t("experience.table_problems.validation.repeat.problem"), "warning");
          
        } else {
          newModuleProblems = [...tableRecords, newModuleFile];
        }

      } else {
        
        newModuleProblems = [newModuleFile];
      }

      if (!flagExist) {
        setValues((values) => ({ ...values, ModProblem_To_Experience: newModuleProblems }));
        setValues((values) => ({ ...values, catalogproblem_list: newModuleProblems }));

        let catalogproblem_l = "";
        let problemConcat = "";

        newModuleProblems.forEach((element, index) => {

          if (index === 0) {
            catalogproblem_l = catalogproblem_l.concat(element.CatProblem_To_ModProblem.name);
            catalogproblem_l = catalogproblem_l.concat(";", element.matter);
            catalogproblem_l = catalogproblem_l.concat(";", element.solution);

            problemConcat = problemConcat.concat(element.CatProblem_To_ModProblem.id);

          } else {
            catalogproblem_l = catalogproblem_l.concat("|");
            catalogproblem_l = catalogproblem_l.concat(element.CatProblem_To_ModProblem.name);
            catalogproblem_l = catalogproblem_l.concat(";", element.matter);
            catalogproblem_l = catalogproblem_l.concat(";", element.solution);

            problemConcat = problemConcat.concat(";", element.CatProblem_To_ModProblem.id);

          }

        });

        setValues((values) => ({ ...values, catalogproblem_l: catalogproblem_l }));
        setValues((values) => ({ ...values, 'catalogproblem_ids': problemConcat }));

        setAddFormData(initialData)
      }
    }else{
      Swal.fire(t("titles.error"), t("table_data.validation.data.multimedia"), "warning");
    }

  };

  const handleEditFormSubmit = (event) => {

    event.preventDefault();

    const editedContact = {
      id: editContactId,
      CatProblem_To_ModProblem: editFormData.CatProblem_To_ModProblem,
      matter: editFormData.matter,
      solution: editFormData.solution
    };

    const newModuleProblems = [...tableRecords];

    const index = tableRecords.findIndex((tableRecord) => tableRecord.id === editContactId);

    newModuleProblems[index] = editedContact;

    setValues((values) => ({ ...values, ModProblem_To_Experience: newModuleProblems }));
    setValues((values) => ({ ...values, catalogproblem_list: newModuleProblems }));

    let catalogproblem_l = "";
    let problemConcat = "";

    newModuleProblems.forEach((element, index) => {

      if (index === 0) {
        catalogproblem_l = catalogproblem_l.concat(element.CatProblem_To_ModProblem.name);
        catalogproblem_l = catalogproblem_l.concat(";", element.matter);
        catalogproblem_l = catalogproblem_l.concat(";", element.solution);

        problemConcat = problemConcat.concat(element.CatProblem_To_ModProblem.id);

      } else {
        catalogproblem_l = catalogproblem_l.concat("|");
        catalogproblem_l = catalogproblem_l.concat(element.CatProblem_To_ModProblem.name);
        catalogproblem_l = catalogproblem_l.concat(";", element.matter);
        catalogproblem_l = catalogproblem_l.concat(";", element.solution);

        problemConcat = problemConcat.concat(";", element.CatProblem_To_ModProblem.id);

      }

    });

    setValues((values) => ({ ...values, catalogproblem_l: catalogproblem_l }));
    setValues((values) => ({ ...values, 'catalogproblem_ids': problemConcat }));

    setEditContactId(null);
  };

  const handleEditClick = (event, tableRecord) => {
    event.preventDefault();
    setEditContactId(tableRecord.id);

    const formValues = {
      CatProblem_To_ModProblem: tableRecord.CatProblem_To_ModProblem,
      matter: tableRecord.matter,
      solution: tableRecord.solution,
    };

    setEditFormData(formValues);
  };

  const handleCancelClick = () => {
    setEditContactId(null);
  };

  const handleDeleteClick = (contactId) => {
    const newModuleProblems = [...tableRecords];

    const index = tableRecords.findIndex((tableRecord) => tableRecord.id === contactId);

    newModuleProblems.splice(index, 1);

    setValues((values) => ({ ...values, ModProblem_To_Experience: newModuleProblems }));
    setValues((values) => ({ ...values, catalogproblem_list: newModuleProblems }));

    let catalogproblem_l = "";
    let problemConcat = "";

    newModuleProblems.forEach((element, index) => {

      if (index === 0) {
        catalogproblem_l = catalogproblem_l.concat(element.CatProblem_To_ModProblem.name);
        catalogproblem_l = catalogproblem_l.concat(";", element.matter);
        catalogproblem_l = catalogproblem_l.concat(";", element.solution);

        problemConcat = problemConcat.concat(element.CatProblem_To_ModProblem.id);

      } else {
        catalogproblem_l = catalogproblem_l.concat("|");
        catalogproblem_l = catalogproblem_l.concat(element.CatProblem_To_ModProblem.name);
        catalogproblem_l = catalogproblem_l.concat(";", element.matter);
        catalogproblem_l = catalogproblem_l.concat(";", element.solution);

        problemConcat = problemConcat.concat(";", element.CatProblem_To_ModProblem.id);
      }

    });

    setValues((values) => ({ ...values, catalogproblem_l: catalogproblem_l }));
    setValues((values) => ({ ...values, 'catalogproblem_ids': problemConcat }));

  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (

    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
        {t(`${moduleText}.short.${field}`)}</label>
      <div>
        <div className="app-container-tee">
          <div className="form-tee">
            {/*<form onSubmit={handleEditFormSubmit}>*/}

            {/*<table className="table">
              <thead>
                <tr>
                  <th style={{width:'40%'}}>Column 1</th>
                  <th style={{width:'25%'}}>Column 2</th>
                  <th style={{width:'25%'}}>Column 3</th>
                  <th style={{width:'10%'}}>Column 4</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{width:'40%'}}>Data 1</td>
                  <td style={{width:'25%'}}>Data 2</td>
                  <td style={{width:'25%'}}>Data 3</td>
                  <td style={{width:'10%'}}>Data 4</td>
                </tr>
              </tbody>
            </table>*/}

            <table className="table">
              <thead>
                <tr>
                  <th style={{width:'40%'}}>{t('experience.table_problems.problems')}</th>
                  <th style={{width:'25%'}}>{t('experience.table_problems.matter')}</th>
                  <th style={{width:'25%'}}>{t('experience.table_problems.solution')}</th>
                  <th style={{width:'10%'}}>{t('experience.table_problems.actions')}</th>
                </tr>
              </thead>
              <tbody>
                {tableRecords && tableRecords.length > 0 &&
                  tableRecords.map((tableRecord) => (
                    <Fragment key={tableRecord.id}>
                      {editContactId === tableRecord.id ? (
                        <EditableRow
                          editFormData={editFormData}
                          handleEditFormChange={handleEditFormChange}
                          handleCancelClick={handleCancelClick}
                          handleEditFormSubmit={handleEditFormSubmit}
                          
                          data={comboData}
                        />
                      ) : (
                        <ReadOnlyRow
                          tableRecord={tableRecord}
                          handleEditClick={handleEditClick}
                          handleDeleteClick={handleDeleteClick}
                        />
                      )}
                    </Fragment>
                  ))}
              </tbody>
            </table>
          </div>
          {/*</form>*/}
          <div className="tit-view-view subtitle-tit">{t('experience.table_problems.add_problem')}</div>
          {/*<form onSubmit={handleAddFormSubmit}>*/}
          <div className="row g-0">

            <div style={{width:'40%'}}>
              <label htmlFor="CatProblem_To_ModProblem" className="form-label label-information">{t('experience.table_problems.problems')}</label>
              <Select
                styles={customStyles}
                
                myFontSize="14px"
                style={{ width: "100%" }}
                onChange={(event) => handleChange(event, "CatProblem_To_ModProblem", "relation")}
                
                classNamePrefix="select"
                
                name="CatProblem_To_ModProblem"
                
                inputId="CatProblem_To_ModProblem"

                value={addFormData.CatProblem_To_ModProblem}

                options={comboData}
                getOptionLabel={(option) => catalogTableLabel(option)}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                placeholder={t('experience.table_problems.problems')}
              />
            </div>
            <div style={{width:'25%'}}>
              <label htmlFor="matter" className="form-label label-information">{t('experience.table_problems.matter')}</label>
              <TextareaAutosize
                cacheMeasurements
                className="form-control"
                aria-label="empty textarea"
                style={{ width: "100%" }}
                onChange={(event) => handleChange(event, "matter", "text")}
                maxRows={5}
                name="matter"
                id="matter"
                value={addFormData.matter}
                required
                maxLength="200"
                placeholder={t('experience.table_problems.matter')}
              ></TextareaAutosize>
            </div>

            <div style={{width:'25%'}}>
              <label htmlFor="solution" className="form-label label-information">{t('experience.table_problems.solution')}</label>
              <TextareaAutosize
                cacheMeasurements
                className="form-control"
                aria-label="empty textarea"
                style={{ width: "100%" }}
                onChange={(event) => handleChange(event, "solution", "text")}
                maxRows={5}
                name="solution"
                id="solution"
                value={addFormData.solution}
                required
                maxLength="400"
                placeholder={t('experience.table_problems.solution')}
              ></TextareaAutosize>
            </div>

            <div style={{width:'10%'}}>
              <label htmlFor="button-add" className="form-label label-information">{t('experience.table_problems.options')}</label>
              <button
                id="button-add"
                style={{ width: "80%", height: "54px" }}
                onClick={handleAddFormSubmit}
                className="table-button-preview"
              >
                <i className="fa fa-plus" style={{ fontSize: "48px" }}></i>
              </button>
            </div>
          </div>
          {/*<button type="submit">Add</button>*/}
          {/*</form>*/}
        </div>
      </div>
    </div>

  );
};

export default NewCatalogRelationProblemsDetails;
